<template>
  <div class="refresh-tip" id="refresh-tip">
    <div class="_tip-title">
      有新版本发布，请关闭网页重新访问
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.refresh-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #1da57a;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  display: none;
  i {
    cursor: pointer;
  }
}
</style>
